'use client';

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

interface Props {
  data: Record<string, number>;
}

const BENEFIT_SHORT: Record<string, string> = {
  'School Uniform': 'Uniform',
  'Stationery': 'Stationery',
  'Sanitary Pads': 'San. Pads',
  'Emergency Medical Advance': 'Medical',
  'School Trip Lunch Box': 'Lunch Box',
  'Data / Library Transport': 'Data',
  'Birthday Outings': 'Birthday',
  'Teacher Progress Check': 'Progress',
  'Post-Matric Support': 'Post-Mat.',
  'Skills Development': 'Skills',
  'Life Skills Development Program': 'Life Skills',
  'On-Site School Safety': 'Safety',
  'Death of a Parent/Guardian Benefit': 'Death Ben.',
};

const COLORS = [
  'var(--primary)',
  '#0d9488',
  '#d97706',
  '#ec4899',
  '#6366f1',
  '#f59e0b',
  '#10b981',
  '#ef4444',
  '#8b5cf6',
  '#06b6d4',
  '#84cc16',
  '#f97316',
  '#e11d48',
];

export default function AdminBenefitChart({ data }: Props) {
  const chartData = Object.entries(data)
    .map(([name, count]) => ({
      name: BENEFIT_SHORT[name] || name.slice(0, 10),
      count,
      fullName: name,
    }))
    .sort((a, b) => b.count - a.count);

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart
        data={chartData}
        margin={{ top: 5, right: 10, left: -20, bottom: 40 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 10, fill: 'var(--muted-foreground)' }}
          angle={-35}
          textAnchor="end"
          interval={0}
        />
        <YAxis
          tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
          allowDecimals={false}
        />
        <Tooltip
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              return (
                <div className="bg-card border border-border rounded-xl shadow-lg px-3 py-2">
                  <p className="text-xs font-semibold text-foreground mb-0.5">
                    {payload[0].payload.fullName}
                  </p>
                  <p className="text-sm font-bold text-primary">
                    {payload[0].value} children
                  </p>
                </div>
              );
            }
            return null;
          }}
        />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-benefit-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}